const injectHelperIntoTemplate = (template, helper) => {
  if (!helper || !template) return template;
  let result = template.replace(/{{{([^{}]+)}}}/g, `{{{${helper} $1}}}`);
  result = result.replace(/{{([^{}]+)}}(?!})/g, `{{${helper} $1}}`);
  return result;
};
export default injectHelperIntoTemplate;
//# sourceMappingURL=inject-helper-into-template.js.map